import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/auth/authService';
import store from '@/store/store';
import commonFunc from '@/common/commonFunction';
import util from '@/common/utility';
import { ModuleOrganization } from '@/store/module-const';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
Vue.use(Router);
const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '',
			component: () => import('@/layouts/main/Main.vue'),
			children: [
				{
					path: '/',
					redirect: '/callback',
					meta: {
						requiresAuth: true
					}
				},
				// =============================================================================
				// Tổng quan
				// =============================================================================
				{
					path: '/dashboard',
					name: 'dashboard',
					component: () => import(/*webpackChunkName:'dashboard'*/ '@/views/dashboard/DashboardManage.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Màn hình tổng quan
						// =============================================================================
						{
							path: '/dashboard/overview',
							name: 'dashboard',
							component: () =>
								import(/*webpackChunkName:'dashboard'*/ '@/views/dashboard/DashboardV3.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Trợ thủ AI - MISA AVA
						// =============================================================================
						{
							path: '/dashboard/ava-dashboard',
							name: 'ava-dashboard',
							component: () =>
								import(/*webpackChunkName:'dashboardAva'*/ '@/views/dashboard/AvaIntroduction.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Màn hình quy trình nghiệp vụ
						// =============================================================================
						{
							path: '/dashboard/proccess',
							name: 'proccess',
							component: () =>
								import(/*webpackChunkName:'dashboardProcess'*/ '@/views/dashboard/ProcessService.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				//=============================================================================
				//Hóa đơn đầu vào
				//=============================================================================
				{
					path: '/invoice',
					name: 'invoice',
					component: () => import(/*webpackChunkName:'invoice'*/ '@/views/Invoice/InvoiceManagement.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Danh sách hóa đơn đầu vào
						// =============================================================================
						{
							path: '/invoice/list',
							name: 'invoices',
							component: () => import(/*webpackChunkName:'invoice'*/ '@/views/Invoice/InvoiceListV2.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Danh sách hóa đơn đầu vào đã xóa
						// =============================================================================
						{
							path: '/invoice/loading',
							name: 'invoice-loading',
							component: () =>
								import(/*webpackChunkName:'invoiceLoading'*/ '@/views/Invoice/InvoiceLoadingList.vue'),
							meta: { requiresAuth: true }
						},
						{
							path: '/invoice/trash',
							name: 'trashinvoices',
							component: () =>
								import(/*webpackChunkName:'invoiceTrash'*/ '@/views/InvoiceTrash/InvoiceTrash.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Hóa đơn đầu ra
				// =============================================================================
				{
					path: '/outinvoice',
					name: 'outinvoice',
					component: () => import(/*webpackChunkName:'outInvoice'*/ '@/views/OutInvoice/OutInvoice.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Danh sách hóa đơn đầu ra
						// =============================================================================
						{
							path: '/outinvoice/list',
							name: 'outinvoices',
							component: () =>
								import(/*webpackChunkName:'outInvoice'*/ '@/views/OutInvoice/OutInvoiceList.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Danh sách hóa đơn đầu ra đã xóa
						// =============================================================================
						{
							path: '/outinvoice/loading',
							name: 'outinvoice-loading',
							component: () =>
								import(
									/*webpackChunkName:'outInvoiceLoading'*/ '@/views/OutInvoice/OutInvoiceLoadingList.vue'
								),
							meta: { requiresAuth: true }
						},
						{
							path: '/outinvoice/trash',
							name: 'trashoutinvoice',
							component: () =>
								import(/*webpackChunkName:'outInvoiceTrash'*/ '@/views/OutInvoice/OutInvoiceTrash.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Tờ khai hải quan
				// dqduy 24.01.2024
				// =============================================================================
				{
					path: '/customsdeclaration',
					name: 'customsdeclaration',
					component: () =>
						import(
							/*webpackChunkName:'declaration'*/ '@/views/CustomsDeclaration/DeclarationManagement.vue'
						),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Danh sách tờ khai
						// =============================================================================
						{
							path: '/customsdeclaration/list',
							name: 'customsdeclarations',
							component: () =>
								import(
									/*webpackChunkName:'declaration'*/ '@/views/CustomsDeclaration/CustomsDeclarationList.vue'
								),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Danh sách tờ khai đã bị xóa
						// =============================================================================
						{
							path: '/customsdeclaration/trash',
							name: 'trashcustomsdeclaration',
							component: () =>
								import(
									/*webpackChunkName:'declarationTrash'*/ '@/views/CustomsDeclaration/CustomsDeclarationTrash.vue'
								),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Hộp thư
				// =============================================================================
				{
					path: '/mail',
					name: 'inboxmanagement',
					component: () => import(/*webpackChunkName:'inbox'*/ '@/views/inbox/InboxManagement.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Hộp thư đến
						// =============================================================================
						{
							path: '/mail/inbox',
							name: 'inbox',
							component: () => import(/*webpackChunkName:'inbox'*/ '@/views/inbox/InboxV2.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Thư quan trọng
						// =============================================================================
						{
							path: '/mail/importantbox',
							name: 'importantbox',
							component: () => import(/*webpackChunkName:'inboxImpotant'*/ '@/views/inbox/InboxV2.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Thư rác
						// =============================================================================
						{
							path: '/mail/spambox',
							name: 'spambox',
							component: () => import(/*webpackChunkName:'inboxSpam'*/ '@/views/inbox/Spambox.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Thùng rác
						// =============================================================================
						{
							path: '/mail/trashbox',
							name: 'trashbox',
							component: () => import(/*webpackChunkName:'inboxTrash'*/ '@/views/inbox/Trashbox.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Nhà cung cấp
				// =============================================================================
				{
					path: '/supplier',
					name: 'supplier',
					component: () => import(/*webpackChunkName:'supplier'*/ '@/views/supplier/SupplierList.vue'),
					meta: {
						requiresAuth: true
					}
				},
				// =============================================================================
				// Cơ cấu tổ chức
				// =============================================================================
				{
					path: '/organization',
					name: 'organization',
					component: () =>
						import(/*webpackChunkName:'organization'*/ '@/views/organization/OrganizationStructure.vue'),
					meta: {
						requiresAuth: true
					}
				},
				// =============================================================================
				// Kết nối nhà cung cấp hóa đơn
				// =============================================================================
				{
					path: '/connectinvoices',
					name: 'connectinvoices',
					component: () =>
						import(/*webpackChunkName:'connectinvoice'*/ '@/views/connectInvoice/ConnectInvoices.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Nhà cung cấp
						// =============================================================================
						{
							path: '/connectinvoices/list',
							name: 'connectlist',
							component: () =>
								import(/*webpackChunkName:'connectinvoice'*/ '@/views/connectInvoice/ListConnect.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Đã kết nối
						// =============================================================================
						{
							path: '/connectinvoices/connected',
							name: 'connected',
							component: () =>
								import(/*webpackChunkName:'connectinvoice'*/ '@/views/connectInvoice/Connected.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Kết nối dữ liệu cơ quan thuế
				// =============================================================================
				{
					path: '/connecttaxaxions',
					name: 'connecttaxaxions',
					component: () =>
						import(/*webpackChunkName:'connecttaxaxions'*/ '@/views/connectInvoice/ConnectTaxaxions.vue'),
					meta: {
						requiresAuth: true
					}
				},
				// =============================================================================
				// Hệ thống
				// =============================================================================
				{
					path: '/system',
					name: 'system',
					component: () => import(/*webpackChunkName:'system'*/ '@/views/system/System.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Nhật ký truy cập
						// =============================================================================
						{
							path: '/system/auditinglog',
							name: 'auditinglog',
							component: () =>
								import(/*webpackChunkName:'auditinglog'*/ '@/views/auditinglog/AuditingLogList.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Tùy chọn thiết lập
						// =============================================================================
						{
							path: '/system/setting',
							name: 'settingsystem',
							component: () =>
								import(/*webpackChunkName:'settingsystem'*/ '@/views/setting/SettingSystem.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Quản lý người dùng
						// =============================================================================
						{
							path: '/system/user',
							name: 'user',
							component: () => import(/*webpackChunkName:'user'*/ '@/views/usermanager/UserList.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Vai trò quyền hạn
						// =============================================================================
						{
							path: '/system/role',
							name: 'role',
							component: () => import(/*webpackChunkName:'role'*/ '@/views/role/RoleList.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Quản lý tài nguyên
						// =============================================================================
						{
							path: '/system/resource',
							name: 'resource',
							component: () => import(/*webpackChunkName:'resource'*/ '@/views/resources/Resources.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Lịch sử chấp nhận thuế suất
						// =============================================================================
						{
							path: '/system/history-vat-rate',
							name: 'historyvatrate',
							component: () =>
								import(/*webpackChunkName:'historyvatrate'*/ '@/views/GoodsVatRate/HistoryVatRate.vue'),
							meta: {
								requiresAuth: true
							}
						},
						// =============================================================================
						// Thiết lập người dùng
						// =============================================================================
						{
							path: '/system/user-setup',
							name: 'usersetup',
							component: () => import(/*webpackChunkName:'usersetup'*/ '@/views/usersetup/UserSetup.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Báo cáo
				// =============================================================================
				{
					path: '/report',
					name: 'report',
					component: () => import(/*webpackChunkName:'report'*/ '@/views/report/Report.vue'),
					meta: {
						requiresAuth: true
					},
					children: [
						// =============================================================================
						// Tất cả báo cáo
						// =============================================================================
						{
							path: '/report/allReport',
							name: 'allReport',
							component: () => import(/*webpackChunkName:'report'*/ '@/views/report/AllReportList.vue'),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				// =============================================================================
				// Báo cáo hóa đơn rủi ro theo nhà cung cấp
				// =============================================================================
				{
					path: '/report/report-invoice-risk-by-supplier',
					name: 'reportInvoiceRiskBySupplier',
					component: () =>
						import(
							/*webpackChunkName:'reportInvoiceRiskBySupplier'*/ '@/views/report/ReportInvoiceRiskBySupplier/ReportInvoiceRiskBySupplierList.vue'
						),
					meta: {
						requiresAuth: true
					}
				},
				// =============================================================================
				// Báo cáo hóa đơn theo tình trạng hoạt động của NCC
				// =============================================================================
				{
					path: '/report/report-invoice-by-supplier-active',
					name: 'reportInvoiceSupplierActiveList',
					component: () =>
						import(
							/*webpackChunkName:'reportInvoiceSupplierActiveList'*/ '@/views/report/ReportInvoiceSupplierActive/ReportInvoiceSupplierActiveList.vue'
						),
					meta: {
						requiresAuth: true
					}
				},
				// Báo cáo hóa đơn liên quan
				{
					path: '/report/report-invoice-related',
					name: 'reportInvoiceRelated',
					component: () =>
						import(
							/*webpackChunkName:'reportInvoiceRelated'*/ '@/views/report/ReportInvoiceRelated/ReportInvoiceRelated.vue'
						),
					meta: {
						requiresAuth: true
					}
				},
				// Báo cáo tổng hợp chi phí
				{
					path: '/report/report-cost-summary',
					name: 'reportCostSummary',
					component: () =>
						import(
							/*webpackChunkName:'reportCostSummary'*/ '@/views/report/ReportCostSummary/ReportCostSummaryList.vue'
						),
					meta: {
						requiresAuth: true
					}
				},
				// Báo cáo thống kê chi phí theo nhãn dán
				{
					path: '/report/report-invoice-stick',
					name: 'reportInvoiceStick',
					component: () =>
						import(
							/*webpackChunkName:'reportInvoiceStick'*/ '@/views/report/ReportInvoiceStick/ReportInvoiceStick.vue'
						),
					meta: {
						requiresAuth: true
					}
				},
				//Báo cáo vượt định mức chi phí
				{
					path: '/report/report-exceed-cost',
					name: 'reportExceedCost',
					component: () =>
						import(/*webpackChunkName:'reportExceedCost'*/ '@/views/report/ReportExceedCost.vue'),
					meta: {
						requiresAuth: true
					}
				},
				//Báo cáo loại chi phí và định mức
				{
					path: '/report/report-cost-type-and-cost',
					name: 'reportCostTypeAndCost',
					component: () =>
						import(/*webpackChunkName:'reportCostTypeAndCost'*/ '@/views/report/ReportTypeAndCost.vue'),
					meta: {
						requiresAuth: true
					}
				}
			],
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/started',
			name: 'started',
			component: () => import(/*webpackChunkName:'started'*/ '@/views/started/Started.vue'),
			meta: {
				requiresAuth: true
			}
		},
		// =============================================================================
		// Callback
		// =============================================================================
		{
			path: '/callback',
			name: 'callback',
			component: () => import(/*webpackChunkName:'router'*/ '@/pages/Callback.vue'),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/enablenewuser',
			name: 'enablenewuser',
			component: () => import(/*webpackChunkName:'router'*/ '@/views/started/EnableNewUser.vue'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/invoice/:id',
			name: 'invoiceId',
			component: () => import(/*webpackChunkName:'invoicedetail'*/ '@/views/Invoice/InvoiceDetail.vue'),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/outinvoice/:id',
			name: 'outinvoiceId',
			component: () => import(/*webpackChunkName:'outinvoicedetail'*/ '@/views/OutInvoice/OutInvoiceDetail.vue'),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/customsdeclaration/:id',
			name: 'customsdeclarationId',
			component: () =>
				import(
					/*webpackChunkName:'declarationdetail'*/ '@/views/CustomsDeclaration/CustomsDeclarationDetail.vue'
				),
			meta: {
				requiresAuth: true
			}
		},
		// =============================================================================
		// Dùng thử hóa đơn
		// =============================================================================
		{
			path: '/invoicetrial/:id',
			name: 'invoiceTrial',
			component: () => import(/*webpackChunkName:'trial'*/ '@/views/InvoiceTrial/InvoiceTrial.vue'),
			meta: {
				requiresAuth: false,
				forceRouter: true
			}
		},
		// =============================================================================
		// View hóa đơn cho các bên tích hợp không cần authen
		// =============================================================================
		{
			path: '/viewinvoice',
			name: 'viewinvoice',
			component: () => import(/*webpackChunkName:'integration'*/ '@/views/Invoice/ViewInvoice.vue'),
			meta: {
				requiresAuth: false,
				forceRouter: true
			}
		},
		// =============================================================================
		// Cảnh báo lỗi khi dùng thử hóa đơn
		// =============================================================================
		{
			path: '/errortrial',
			name: 'errortrial',
			component: () => import(/*webpackChunkName:'trial'*/ '@/views/InvoiceTrial/ErrorTrial.vue'),
			meta: {
				requiresAuth: false,
				forceRouter: true
			}
		},
		{
			path: '/pages/error-404',
			name: 'pageError404',
			component: () => import(/*webpackChunkName:'router'*/ '@/pages/Error404.vue'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/pages/not-permission',
			name: 'notPermission',
			component: () => import(/*webpackChunkName:'router'*/ '@/pages/NotPermission.vue'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/pages/error-500',
			name: 'pageError500',
			component: () => import(/*webpackChunkName:'router'*/ '@/pages/Error500.vue'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/pages/notauthorized',
			name: 'notauthorized',
			component: () => import(/*webpackChunkName:'router'*/ '@/pages/NotAuthorized.vue'),
			meta: {
				requiresAuth: false
			}
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404',
			meta: {
				requiresAuth: false
			}
		},
		// =============================================================================
		// Token page
		// =============================================================================
		{
			path: '/token',
			name: 'token',
			component: () => import('@/pages/Token.vue'),
			meta: {
				requiresAuth: true
			}
		},
		// =============================================================================
		// Token data page
		// =============================================================================
		{
			path: '/token_data',
			name: 'token_data',
			component: () => import('@/pages/TokenData.vue'),
			meta: {
				requiresAuth: true
			}
		}
	]
});

let routerOnReady = async function() {
	// let res = await store.dispatch(`${ModuleOrganization}/getSubscriber`);
};

let routerOnError = function(error) {
	commonFunc.errorLogging(error);
};

router.onError(error => {
	const pattern = /Loading chunk (\S)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	if (isChunkLoadFailed) {
		window.location.reload(); // reload lại trang khi chunk load fail
	}
	// Bắt cả lỗi props undefined khi F5
	if (error.message.includes('Cannot read properties of undefined')) {
		console.error('Route render error:', error);
		// tùy chọn: redirect về trang an toàn
	}
});

router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
	commonFunc.unmask();
});

let localeRestored = false;
router.beforeEach(async (to, from, next) => {
	//Đợi load State do dùng IndexDb,...
	await store.restored;

	//Restore ngôn ngữ từ storage 1 lần duy nhất khi app khởi động
	if (!localeRestored) {
		localeRestored = true;
		await commonFunc.initSupportLanguage();
	}

	if (to.meta.forceRouter) {
		return next();
	}

	//Không cần check xác thực với những màn đã cấu hình trong router
	if (!to.meta.requiresAuth) {
		//Nếu đã đăng nhập thì cho vào ứng dụng luôn
		if (auth.isAuthenticated() && to.name != 'pageError404' && to.name != 'pageError500') {
			return next('/');
		} else {
			return next();
		}
	} else {
		//Kiểm tra xem đã xác thực hay chưa?
		if (auth.isAuthenticated()) {
			//Nếu chưa có Chi nhánh, phòng ban làm việc
			let organizationWorking = store.getters['organization/getOrganizationWorking'];
			if ((!organizationWorking || !organizationWorking.Id) && to.path != '/callback' && to.path != '/started') {
				if (to.name == 'invoiceId' || to.name == 'outinvoiceId' || to.name == 'customsdeclarationId') {
					return next('/callback?ReturnUrl=' + to.fullPath); //Điều hướng sang callback để lấy lại dữ liệu
				} else {
					return next('/callback'); //Điều hướng sang callback để lấy lại dữ liệu
				}
			} else {
				//hvanh: PBI-547654: Router Guard - Check Third Party Organization Access
				if (organizationWorking && organizationWorking.IsCheckThirdParty) {
					const config = window.__env.thirdPartyOrganizationConfig;

					if (config && config.blockedRoutePatterns) {
						// Check xem route hiện tại có bị chặn không
						const isBlocked = config.blockedRoutePatterns.some(pattern => {
							return pattern.test(to.path);
						});

						if (isBlocked) {
							// Redirect về danh sách hóa đơn (phân hệ chính)
							return next('/invoice/list');
						}
					}
				}

				return next();
			}
		} else {
			window.location =
				window.__env.authConfig.root_url + '/login/1?ReturnUrl=' + encodeURI(`/inbot${to.fullPath}/`);
		}
	}
});

export default router;
